<template>
    <p
        class="ProductStatus"
        :class="{
            'ProductStatus--available': productStock.status.id === 'available',
            'ProductStatus--onOrder': productStock.status.id === 'on_order',
            'ProductStatus--unavailable':
                productStock.status.id === 'unavailable',
        }"
    >
        <span>{{ productStock.status.name }}</span><span v-if="productStock.delivery_time_in_days > 0">,&nbsp;в&nbsp;течение {{ productStock.delivery_time_in_days }} {{ productStock.day_format }}</span>
        <button class="Button Button--lightGray" style="padding: 10px;" v-if="productStock.status.id === 'unavailable'" data-uk-toggle="target: #part-request-modal" @click="setPart">Сообщить о поступлении</button>
    </p>
</template>

<script>
import { reduceStocks } from '@scripts/helpers';

export default {
    props: {
        stocks: Array,
        quantity: {
            type: Number,
            default: 0,
        },
        quantityInPackage: {
            type: Number,
            required: true,
        },
        isUserWholesaler: {
            type: Boolean,
            required: true,
        },
        partVendorCode: {
            type: String,
            required: false,
        }
    },
    data() {
        return {
            mappedStocks: [],
        };
    },
    beforeMount() {
        // Mapped stocks used for correct status check
        // [{ amount_in_packages: 5 }, { amount_in_packages: 7}] => [{ amount_in_packages: 5 }, { amount_in_packages: 12 }]
        // So if we have 9 packages, we use second status (because quantity > 5, but less than 12)
        this.mappedStocks = reduceStocks(this.stocks);
    },
    methods: {
        setPart: function (event) {
            // formData.part = this.partVendorCode;
	        // partRequest.setCurrentPart(this.partVendorCode);
            document.getElementById('part-request-part').value = this.partVendorCode;
        }
    },
    computed: {
        // Last status always be `not_available` or smth similar
        // ask @chst_feip
        productStock() {
            let quantity = this.quantity;
            if (this.isUserWholesaler) {
                quantity /= this.quantityInPackage;
            }

            const productStock = this.mappedStocks.find((stock) => quantity <= stock.amount_in_packages)
                ?? this.mappedStocks[this.mappedStocks.length - 1];

            const dayFormat = this.pluralize(productStock.delivery_time_in_days, ['дня', 'дней', 'дней']);
            
            // console.log(this.partId);
            
            return ({
                ...productStock,
                day_format: dayFormat,
            });
        },
    },
};
</script>
